<template>
	<div v-show="tablePagination && tablePagination.last_page > 1" :class="css.wrapperClass">
		<a v-if="windowStart > 1" @click="loadPage(1)" :class="[isOnFirstPage ? css.disabledClass : '']">1</a>
		<span v-if="windowStart > 2">...</span>
		<template v-if="notEnoughPages">
			<template v-for="n in totalPage">
				<a @click="loadPage(n)"
				   :class="[css.pageClass, isCurrentPage(n) ? css.activeClass : '']"
				   v-html="n">
				</a>
			</template>
		</template>
		<template v-else>
			<template v-for="n in windowSize">
				<a @click="loadPage(windowStart+n-1)"
				   :class="[css.pageClass, isCurrentPage(windowStart+n-1) ? css.activeClass : '']"
				   v-html="windowStart+n-1">
				</a>
			</template>
			<span v-if="windowEnd < (totalPage - 1)">...</span>
			<a v-if="windowEnd < totalPage" @click="loadPage(totalPage)"
			   :class="[ isOnLastPage ? css.disabledClass : '']" v-html="totalPage"></a>
		</template>
	</div>
</template>

<script>
	import PaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin';

	export default {
		mixins: [PaginationMixin],
		computed: {
			windowEnd () {
				if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
					return this.windowSize;
				} else if (this.tablePagination.current_page >= (this.totalPage - this.onEachSide)) {
					return this.totalPage;
				}

				return this.tablePagination.current_page + this.onEachSide
			},
		}
	}
</script>
